import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Window } from 'types';

export const deleteWindow = (windowId: number) => {
  return axios.delete(`/api/windows/${windowId}`);
};

type UseDeleteWindowOptions = {
  wallId: number;
  config?: MutationConfig<typeof deleteWindow>;
};

export const useDeleteWindow = ({ wallId, config }: UseDeleteWindowOptions) => {
  return useMutation({
    onMutate: async (deletedWindowId: number) => {
      await queryClient.cancelQueries(['windows', wallId]);

      const previousWindows = queryClient.getQueryData<Window[]>([
        'windows',
        wallId,
      ]);

      queryClient.setQueryData(
        ['windows', wallId],
        previousWindows?.filter((window) => window.id !== deletedWindowId)
      );

      return { previousWindows };
    },
    onError: (_, __, context: any) => {
      if (context?.previousWindows) {
        queryClient.setQueryData(['windows', wallId], context.previousWindows);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['windows', wallId]);
      queryClient.invalidateQueries(['wall', wallId]);
    },
    ...config,
    mutationFn: deleteWindow,
  });
};
